<template>
  <div id="tsl-document">
    <v-btn color="primary" class="my-2" :disabled="addNew" @click="addNew = !addNew" outlined>
      {{ $t('companiesDetails.addDoc') }}
    </v-btn>
    <v-row no-gutters>
      <v-col cols="12" lg="7" xl="6">
        <v-expansion-panels v-if="addNew" v-model="newDocumentPanel" multiple flat class="justify-start" active-class="my-2">
          <v-expansion-panel readonly class="outlined">
            <v-expansion-panel-header expand-icon="" />
            <v-expansion-panel-content>
              <TSLDocumentNew
                :type="documentType"
                :loading="loading"
                @submit="submitHandler"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" lg="7" xl="6">
        <v-expansion-panels v-model="documentPanel" flat multiple active-class="my-2">
          <v-expansion-panel v-for="document in documents" :key="document.id" class="outlined">
            <v-expansion-panel-header class="font-weight-bold" expand-icon="$sort">
              <h4 class="ml-4 primary--text">{{ document.description }}</h4>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <TSLDocumentItem
                :document="document"
                :loading="loading"
                :contractor-id="contractorId"
                @update="documentUpdate"
                @remove="documentRemove"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-progress-linear v-if="loading" indeterminate />
  </div>
</template>

<script>
import Service from '@/services'
import TSLDocumentNew from './TSLDocumentNew.vue'
import TSLDocumentItem from './TSLDocumentItem.vue'

export default {
  name: 'TSLDocumentsList',
  components: {
    TSLDocumentNew,
    TSLDocumentItem
  },
  props: {
    documentType: {
      type: Number,
      required: true
    },
    contractorId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      addNew: false,
      documents: [],
      documentPanel: [0],
      newDocumentPanel: [0]
    }
  },
  created () {
    this.getDocuments()
  },
  methods: {
    update () {
      this.$emit('update')
    },
    async getDocuments () {
      this.loading = true
      try {
        const { data } = await Service.get('/TSLContractor/GetDocuments', {
          contractorId: this.contractorId,
          documentType: this.documentType
        })
        this.documents = data || []
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading documents')
      } finally {
        this.loading = false
      }
    },
    async documentUpdate (updateData) {
      this.loading = true
      try {
        await Service.put('/TSLContractor/UpdateDocument/document', {
          contractorId: updateData.contractorId,
          documentId: updateData.documentId,
          description: updateData.description,
          validIndefinitely: updateData.validIndefinitely,
          validTo: updateData.validTo
        })
        await this.getDocuments()
        await this.$store.dispatch('setSuccessNotification', this.$t('companiesDetails.update'))
        this.update()
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error updating document')
      } finally {
        this.loading = false
      }
    },
    async documentRemove (documentId) {
      this.loading = true
      try {
        await Service.put('/TSLContractor/archivedocument/document/archive', {
          contractorId: this.contractorId,
          documentId: documentId
        })
        await this.getDocuments()
        await this.$store.dispatch('setSuccessNotification', this.$t('companiesDetails.remove'))
        this.update()
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error archiving document')
      } finally {
        this.loading = false
      }
    },
    async submitHandler (document) {
      this.loading = true
      var formData = new FormData()

      formData.append('Document.ContractorId', this.contractorId)
      formData.append('Document.Type', document.type)
      formData.append('Document.Description', document.description)
      formData.append('Document.ValidIndefinitely', document.validIndefinitely)
      formData.append('Document.ValidTo', document.validTo)

      document.files.forEach(file => {
        formData.append('Document.Files', file, file.name)
      })

      try {
        await Service.post('/TSLContractor/uploaddocument/document', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        this.addNew = false
        await this.getDocuments()
        await this.$store.dispatch('setSuccessNotification', this.$t('companiesDetails.add'))
        this.update()
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error uploading document')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
#tsl-document .v-expansion-panel.outlined {
  border: thin solid var(--v-primary-base);
  border-bottom: none;
}
#tsl-document .v-expansion-panel--next-active,
#tsl-document .v-expansion-panel.outlined:last-child {
  border-bottom: thin solid var(--v-primary-base) !important;
}
#tsl-document .v-expansion-panel--active.outlined {
  border: thin solid var(--v-primary-base);
}
</style>
